import {Record, List} from 'immutable';

import BillPayerShare, {type BillPayerShare as BillPayerShareModel} from './bill-payer-share';

export class SplitConfigurationModel extends Record<{
    shares: List<BillPayerShareModel>;
}>({
    shares: List(),
}) {}

const fromAPI = data => {
    return new SplitConfigurationModel({
        shares: List(data).map(BillPayerShare.fromAPI),
    });
};

const toAPI = splitConfiguration => ({
    billPayerShares: splitConfiguration.shares.map((s, i) => BillPayerShare.toAPI(s, i)),
});

export default {
    record: SplitConfigurationModel,
    default: new SplitConfigurationModel(),
    fromAPI,
    toAPI,
};
